import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext"; // Import useAuth from AuthContext
import axios from "axios";
import SalesForm from "./SalesForm";
import MenuBar from "./TopLeftMenu";
import styled from "styled-components";
import {
  fetchUserStatsByEmail,
  fetchCoreMarketByEmail,
  fetchCountByEmail,
  fetchLeadCountByEmail,
  fetchPUMCountByEmail,
  fetchPUMCoreCountByEmail,
  fetchTableData,
  fetchAgentCoreMarketByEmail,
  fetchAllRexSyncRecords,
  extractAllEmails
} from "../services/airtable";
import { auth, db } from "../firebase"; // Import auth and db from firebase
import { collection, query, where, getDocs } from "firebase/firestore"; // Import Firestore functions

// NEW STYLED COMPONENT FOR THE DROPDOWN CONTAINER
const DropdownContainer = styled.div`
  position: absolute;
  height: 120px; /* Increased height */
  top: 80px; /* Push the dropdown down */
  left: 1130px; /* Push the dropdown to the left */
  z-index: 1000;

  /* Dropdown styling */
  select {
    width: 200px; /* Set a fixed width */
    height: 40px; /* Increased height */
    padding: 8px 12px; /* Add padding */
    font-size: 16px; /* Increase font size */
    font-family: "Arial", sans-serif; /* Use a clean font */
    color: #333; /* Text color */
    background-color: #fff; /* Background color */
    border: 2px solid #ccc; /* Add a border */
    border-radius: 8px; /* Rounded corners */
    outline: none; /* Remove default outline */
    cursor: pointer; /* Show pointer cursor */
    transition: all 0.3s ease; /* Smooth transitions */

    /* Hover effect */
    &:hover {
      border-color: #007bff; /* Change border color on hover */
      box-shadow: 0 0 8px rgba(0, 123, 255, 0.3); /* Add a subtle shadow */
    }

    /* Focus effect */
    &:focus {
      border-color: #007bff; /* Change border color on focus */
      box-shadow: 0 0 8px rgba(0, 123, 255, 0.5); /* Add a stronger shadow */
    }

    /* Option styling */
    option {
      font-size: 16px; /* Increase font size for options */
      padding: 8px 12px; /* Add padding to options */
      background-color: #fff; /* Background color for options */
      color: #333; /* Text color for options */
      transition: background-color 0.3s ease; /* Smooth transitions */

      /* Hover effect for options */
      &:hover {
        background-color: #f0f0f0; /* Change background color on hover */
      }
    }
  }
`;

// UPDATED: Centered container for the second row
const RowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: ${(props) => (props.isSecondRow ? "-40px -15px" : "0 -15px")};

  @media (max-width: 480px) {
    flex-direction: column;
    margin: 0;
  }
`;

const AddButton = styled.button`
  position: absolute;
  top: 0px;
  right: 45px;
  display: none;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #388e3c;
  }
`;

const UpdateButton = styled.button`
  position: absolute;
  top: 0px;
  right: 80px;
  display: none;
  background: #ffa726;
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #fb8c00;
  }
`;

const GaugeContainer = styled.div`
  position: relative;
  top: 25px;
  width: ${(props) =>
    props.size === "large"
      ? "300px"
      : props.isSecondRow
      ? props.size === "mediumLarge"
        ? "380px"
        : "300px"
      : props.size === "mediumLarge"
      ? "300px"
      : "230px"};
  height: ${(props) =>
    props.size === "large"
      ? "300px"
      : props.isSecondRow
      ? props.size === "mediumLarge"
        ? "280px"
        : "270px"
      : props.size === "mediumLarge"
      ? "240px"
      : "200px"};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: 10px -6px;
  left: ${(props) => (props.isSecondRow ? "15px" : "0")};

  &:hover .remove-button,
  &:hover .add-button {
    display: flex;
  }

  &:hover .update-button {
    display: flex;
  }

  @media (max-width: 545px) {
    order: ${(props) =>
      props["data-gauge-index"] === 1 ? -1 : props["data-gauge-index"] === 0 ? 0 : 1};
  }
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 0px;
  right: 10px;
  display: none;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 28px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-size: 12px;

  &:hover {
    background: #d9363e;
  }
`;

const CenteredContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: "Arial", sans-serif;
  color: #333;

  .title {
    font-size: ${(props) =>
      props.title === "GCI"
        ? "2.5rem"
        : props.size === "large"
        ? "1.1rem"
        : "0.75rem"};
    font-weight: bold;
    line-height: 1.2;
    color: #333;
    text-align: center;
    word-wrap: break-word;
  }

  .number {
    font-size: ${(props) =>
      props.title === "GCI"
        ? "2.5rem"
        : props.size === "large"
        ? "2.2rem"
        : "1.4rem"};
    font-weight: bold;
    margin-top: ${(props) =>
      props.title === "Live Listings" ? "-10px" : "5px"};
    color: #f7941d;
    position: absolute;
    bottom: ${(props) =>
      props.title === "GCI Settled"
        ? "-90px"
         : props.title === "GCI Projected"
        ? "-90px"
        : props.title === "Office Ranking"
        ? "-47px"
        : props.title === "Live Listings"
        ? "-47px"
        : props.gaugeIndex >= 1 && props.gaugeIndex <= 3
        ? "-70px"
        : "-60px"};
  }

  .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const formatNumberForDisplay = (number, gaugeIndex) => {
  if (typeof number === "number" || !isNaN(number)) {
    const parsedNumber = parseFloat(number);
    const prefix = (gaugeIndex === 1 || gaugeIndex === 2) ? '$' : '';

    if (parsedNumber >= 1000000) {
      const value = parsedNumber / 1000000;
      return `${prefix}${Number.isInteger(value) ? value : value.toFixed(1)}M`;
    } else if (parsedNumber >= 1000) {
      const value = parsedNumber / 1000;
      return `${prefix}${Number.isInteger(value) ? value : value.toFixed(1)}k`;
    }
    return `${prefix}${parsedNumber}`;
  }
  return number;
};

const generateYellowArc = (
  rangeFrom,
  rangeTo,
  value,
  adjustedRadius,
  circleCenter,
  gaugeIndex
) => {
  // For gaugeIndex 2 (GCI Projected), adjust the value to fit within the range
  if (gaugeIndex === 2) {
    value = Math.max(rangeFrom, Math.min(value, rangeTo));
  }

  const totalRange = rangeTo - rangeFrom;

  const startAngle = 135;
  let endAngle = 135 + ((value - rangeFrom) / totalRange) * 270;

  endAngle = Math.min(endAngle, 405);

  const startRadian = (startAngle * Math.PI) / 180;
  const endRadian = (endAngle * Math.PI) / 180;

  const startX = circleCenter + adjustedRadius * Math.cos(startRadian);
  const startY = circleCenter + adjustedRadius * Math.sin(startRadian);
  const endX = circleCenter + adjustedRadius * Math.cos(endRadian);
  const endY = circleCenter + adjustedRadius * Math.sin(endRadian);

  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  return `M ${startX} ${startY} A ${adjustedRadius} ${adjustedRadius} 0 ${largeArcFlag} 1 ${endX} ${endY}`;
};

const CircularGauge = ({
  title,
  number,
  size,
  isSecondRow,
  gaugeIndex,
  onRemove,
  onAdd,
  onUpdate,
  rangeFrom,
  rangeTo,
  interval,
  tickMarks,
}) => {
  const radius = size === "large" ? 90 : size === "mediumLarge" ? 85 : 75;
  const adjustedRadius = isSecondRow ? radius + 5 : radius;
  const circleCenter = 100;

  // IMPROVED: Smart tick mark rendering that adapts to range
  const renderTicks = () => {
    const ticks = [];
    const numbers = [];
    const startAngle = 135;
    const endAngle = 405;

    const totalRange = rangeTo - rangeFrom;
    const totalTicks = Math.floor(totalRange / interval) + 1;
    
    // IMPROVED: Dynamic spacing based on total ticks
    const isCompactMode = totalTicks > 15;
    const angleIncrement = (endAngle - startAngle) / (totalTicks - 1);

    // IMPROVED: Better spacing logic
    const numberFontSize = isCompactMode ? 7 : 9;
    const tickGap = isCompactMode ? 8 : 12;
    const numberGap = isCompactMode ? 18 : 25;

    // IMPROVED: Only show numbers at major intervals when there are too many ticks
    const numberInterval = isCompactMode ? Math.ceil(totalTicks / 8) : 1;

    for (let i = 0; i < totalTicks; i++) {
      const value = rangeFrom + i * interval;
      const angle = startAngle + i * angleIncrement;
      const radian = (angle * Math.PI) / 180;

      // Calculate tick positions
      const x1 = circleCenter + (adjustedRadius - 2) * Math.cos(radian);
      const y1 = circleCenter + (adjustedRadius - 2) * Math.sin(radian);
      const x2 = circleCenter + (adjustedRadius - tickGap) * Math.cos(radian);
      const y2 = circleCenter + (adjustedRadius - tickGap) * Math.sin(radian);

      // Calculate number positions
      const xText = circleCenter + (adjustedRadius - numberGap) * Math.cos(radian);
      const yText = circleCenter + (adjustedRadius - numberGap) * Math.sin(radian);

      // IMPROVED: Special positioning for key points
      let adjustedXText = xText;
      let adjustedYText = yText;

      // Position adjustments for better readability
      if (angle >= 130 && angle <= 140) {
        // Left side - adjust right
        adjustedXText = xText - 5;
      } else if (angle >= 260 && angle <= 280) {
        // Top - adjust down
        adjustedYText = yText + 5;
      } else if (angle >= 400 && angle <= 410) {
        // Right side - adjust left
        adjustedXText = xText + 5;
      }

      // Determine if this is a major tick (thicker)
      const isMajorTick = i % Math.max(1, Math.floor(totalTicks / tickMarks)) === 0;

      ticks.push(
        <line
          key={`tick-${i}`}
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="#000"
          strokeWidth={isMajorTick ? "2" : "1"}
        />
      );

      // IMPROVED: Only show numbers at reasonable intervals to avoid crowding
      const shouldShowNumber = i % numberInterval === 0 || 
                              i === 0 || 
                              i === totalTicks - 1 ||
                              (isCompactMode && i % Math.ceil(totalTicks / 4) === 0);

      if (shouldShowNumber) {
        numbers.push(
          <text
            key={`number-${i}`}
            x={adjustedXText}
            y={adjustedYText}
            fontSize={numberFontSize}
            textAnchor="middle"
            fill="#333"
            fontFamily="Arial"
            dy="0.3em" // Better vertical alignment
          >
            {formatNumberForDisplay(value, gaugeIndex)}
          </text>
        );
      }
    }

    return { ticks, numbers };
  };

  const { ticks, numbers } = renderTicks();

  const parsedNumber =
    parseFloat(String(number).replace(/[^0-9.]/g, "")) *
    (String(number).includes("M") ? 1e6 : 1);

  const clampedNumber = Math.min(Math.max(parsedNumber, rangeFrom), rangeTo);

  const yellowArcPath = generateYellowArc(
    rangeFrom,
    rangeTo,
    clampedNumber,
    adjustedRadius,
    circleCenter,
    gaugeIndex
  );

  const formattedTitle = () => {
    if ([
      "Settlement Count",
      "Image Ranking",
      "PUM's Referral",
      "Lead Conversion",
      "Office Ranking",
      "PUM's in Core",
      "Live Listings"
    ].includes(title)) {
      return title.split(" ");
    }
    return [title];
  };

  return (
    <GaugeContainer size={size} isSecondRow={isSecondRow}>
      <RemoveButton className="remove-button" onClick={onRemove}>
        ×
      </RemoveButton>
      <AddButton className="add-button" onClick={onAdd}>
        +
      </AddButton>
      <UpdateButton className="update-button" onClick={() => onUpdate(gaugeIndex)}>
        ✎
      </UpdateButton>

      <svg width="100%" height="100%" viewBox="0 0 200 200">
        <defs>
          <mask id={`gaugeMask-${gaugeIndex}`}>
            <rect x="0" y="0" width="200" height="200" fill="white" />
            <rect
              x="0"
              y={
                gaugeIndex === 0 && title === "Settlement Count"
                  ? 160.5
                  : isSecondRow
                  ? 157
                  : 163
              }
              width="300"
              height="100"
              fill="black"
            />
          </mask>
        </defs>

        <circle
          cx={circleCenter}
          cy={circleCenter}
          r={adjustedRadius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="3"
          mask={`url(#gaugeMask-${gaugeIndex})`}
        />

        {yellowArcPath && (
          <path
            d={yellowArcPath}
            fill="none"
            stroke="#f7941d"
            strokeWidth="3"
          />
        )}
        {ticks}
        {numbers}
      </svg>

      <CenteredContent size={size} title={title} gaugeIndex={gaugeIndex}>
        <div className="text-container">
          <div className="title">
            {formattedTitle().map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
          <div className="number">
            {formatNumberForDisplay(number, gaugeIndex)}
          </div>
        </div>
      </CenteredContent>
    </GaugeContainer>
  );
};

const Sales_Admin = ({ userEmail }) => {
  const { user, loading } = useAuth();
  // UPDATED: Fixed gauge configuration with proper ranges and intervals
  const [gauges, setGauges] = useState([
    { 
      title: "Properties Sold", 
      number: "0", 
      size: "mediumLarge", 
      rangeFrom: 0, 
      rangeTo: 200, 
      interval: 20, 
      tickMarks: 10 
    },
    { 
      title: "GCI Settled", 
      number: "0.00", 
      size: "large", 
      rangeFrom: 0, 
      rangeTo: 5000000, 
      interval: 500000,  // Increased interval to reduce crowding
      tickMarks: 10 
    },
    { 
      title: "GCI Projected", 
      number: "0.00", 
      size: "mediumLarge", 
      rangeFrom: 0, 
      rangeTo: 5000000, 
      interval: 500000,   // Increased interval to reduce crowding
      tickMarks: 10 
    },
    { 
      title: "Image Ranking", 
      number: "0", 
      size: "medium", 
      rangeFrom: 0, 
      rangeTo: 200, 
      interval: 20, 
      tickMarks: 10 
    },
    { 
      title: "PUM's Referral", 
      number: "0", 
      size: "medium", 
      rangeFrom: 0, 
      rangeTo: 200, 
      interval: 20, 
      tickMarks: 10 
    },
    { 
      title: "Leads %", 
      number: "0", 
      size: "medium", 
      rangeFrom: 0, 
      rangeTo: 200,     // Changed from 100 to 200 as requested
      interval: 20,     // Changed from 10 to 20 as requested
      tickMarks: 10 
    },
  ]);

  const [userStats, setUserStats] = useState({});
  const [coreMarketData, setCoreMarketData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [newGaugeIndex, setNewGaugeIndex] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [gaugePopupData, setGaugePopupData] = useState({
    title: "",
    number: "",
    rangeFrom: 0,
    rangeTo: 100,
    interval: 10,
    tickMarks: 5,
  });

  // NEW STATE: Store Sales users and selected user email
  const [salesUsers, setSalesUsers] = useState([]);
  const [selectedUserEmail, setSelectedUserEmail] = useState(userEmail); // Default to the passed userEmail

  useEffect(() => {
    const parseNumber = (val) => {
      if (val === null || val === undefined) return 0;
      if (typeof val === "number") return val;
      const s = String(val).trim();
      if (!s) return 0;
      const cleaned = s.replace(/[^0-9.\-]/g, "");
      const n = parseFloat(cleaned);
      return Number.isFinite(n) ? n : 0;
    };

    const ordinalSuffix = (rank) => {
      if (!rank || rank <= 0 || isNaN(rank)) return "";
      const r10 = rank % 10;
      const r100 = rank % 100;
      if (r10 === 1 && r100 !== 11) return "st";
      if (r10 === 2 && r100 !== 12) return "nd";
      if (r10 === 3 && r100 !== 13) return "rd";
      return "th";
    };

    const normalizeEmail = (email) => {
      if (!email) return null;
      return String(email).trim().toLowerCase();
    };

    // IMPROVED: Enhanced email matching function with specific mapping for Michael Power
    const findBestEmailMatch = (targetEmail, availableEmails) => {
      const normalizedTarget = targetEmail.trim().toLowerCase();
      const targetName = normalizedTarget.split('@')[0];
      
      console.log(`🔍 Matching: ${normalizedTarget}, name part: ${targetName}`);
      
      // ADDED: Specific email mappings for known discrepancies
      const specificMappings = {
        'michaelandjamie@imageproperty.com.au': 'michael.power@imageproperty.com.au',
        'michael.h@imageproperty.com.au': 'michael.power@imageproperty.com.au',
        'kirstym@imageproperty.com.au': 'kirsty@imageproperty.com.au',
        'kirsty@imageproperty.com.au': 'kirsty@imageproperty.com.au'
      };

      // Check specific mappings first
      if (specificMappings[normalizedTarget]) {
        const mappedEmail = specificMappings[normalizedTarget];
        if (availableEmails.includes(mappedEmail)) {
          console.log(`✅ Specific mapping found: ${normalizedTarget} -> ${mappedEmail}`);
          return { match: mappedEmail, type: 'specific_mapping' };
        }
      }
      
      // 1. Exact match first
      if (availableEmails.includes(normalizedTarget)) {
        console.log(`✅ Exact match found: ${normalizedTarget}`);
        return { match: normalizedTarget, type: 'exact' };
      }
      
      // 2. Try common variations
      const variations = new Set();
      
      // Domain variations
      const domainVariations = [
        'imageproperty.com.au',
        'imagenoperty.com',
        'imageproperty.com',
        'imagenoperty.com.au'
      ];
      
      // Name variations
      const nameVariations = new Set();
      nameVariations.add(targetName);
      nameVariations.add(targetName.replace(/\./g, '')); // Remove dots
      nameVariations.add(targetName.split('.')[0]); // First part only
      
      // Handle specific known variations
      if (targetName.includes('and')) {
        nameVariations.add(targetName.replace(/and/g, '.'));
      }
      if (targetName.includes('.')) {
        nameVariations.add(targetName.replace(/\./g, 'and'));
      }
      
      // Generate all email variations
      nameVariations.forEach(nameVar => {
        domainVariations.forEach(domainVar => {
          variations.add(`${nameVar}@${domainVar}`);
        });
      });
      
      // Check variations
      for (const variation of variations) {
        if (availableEmails.includes(variation)) {
          console.log(`✅ Variation match found: ${variation}`);
          return { match: variation, type: 'variation' };
        }
      }
      
      // 3. Fuzzy matching by name parts
      const nameParts = targetName.split(/[\.\-\_]+/).filter(part => part.length > 2);
      console.log(`🔍 Name parts for fuzzy matching:`, nameParts);
      
      const fuzzyMatches = availableEmails.filter(email => {
        const emailName = email.split('@')[0];
        const emailNameParts = emailName.split(/[\.\-\_]+/);
        
        // Check if any name part is included in the email name
        return nameParts.some(part => 
          emailNameParts.some(emailPart => 
            emailPart.toLowerCase().includes(part.toLowerCase()) || 
            part.toLowerCase().includes(emailPart.toLowerCase())
          )
        );
      });
      
      if (fuzzyMatches.length === 1) {
        console.log(`✅ Fuzzy match found: ${fuzzyMatches[0]}`);
        return { match: fuzzyMatches[0], type: 'fuzzy' };
      }
      
      // 4. Partial string matching
      const partialMatches = availableEmails.filter(email => {
        const emailName = email.split('@')[0];
        return (
          email.includes(targetName) ||
          targetName.includes(emailName) ||
          emailName.includes(targetName)
        );
      });
      
      if (partialMatches.length === 1) {
        console.log(`✅ Partial match found: ${partialMatches[0]}`);
        return { match: partialMatches[0], type: 'partial' };
      }
      
      // 5. If multiple partial matches, try to find the best one
      if (partialMatches.length > 1) {
        // Prefer matches with similar length
        const bestMatch = partialMatches.find(email => {
          const emailName = email.split('@')[0];
          return Math.abs(emailName.length - targetName.length) <= 2;
        });
        
        if (bestMatch) {
          console.log(`✅ Best partial match found: ${bestMatch}`);
          return { match: bestMatch, type: 'best_partial' };
        }
        
        console.warn(`Multiple partial matches found for ${normalizedTarget}, using first: ${partialMatches[0]}`);
        return { match: partialMatches[0], type: 'multiple_partial' };
      }
      
      console.log(`❌ No match found for ${normalizedTarget}`);
      return null;
    };

    // IMPROVED: Email extraction function
    const extractAllEmails = (fields) => {
      if (!fields) return [];
      
      const emails = new Set();
      
      const emailFieldNames = [
        "Email", "Agent Email", "Image Email", "Email Address", "email", 
        "agent_email", "Image Email (from HR Link)", "Image Email (from HR Sync)",
        "Primary Email", "Contact Email", "Agent_Email", "Image_Email",
        "Agent Email Address", "Official Email", "Work Email"
      ];
      
      // First, check specific email fields directly
      emailFieldNames.forEach(fieldName => {
        if (fields[fieldName] !== undefined && fields[fieldName] !== null) {
          const rawValue = fields[fieldName];
          
          if (Array.isArray(rawValue)) {
            rawValue.forEach(item => {
              const emailValue = processEmailValue(item);
              if (emailValue) emails.add(emailValue);
            });
          } else {
            const emailValue = processEmailValue(rawValue);
            if (emailValue) emails.add(emailValue);
          }
        }
      });
      
      // Check all string fields for email patterns
      Object.keys(fields).forEach(fieldName => {
        if (emailFieldNames.includes(fieldName)) return;
        
        const numericFields = ['GCI', 'Properties Sold', 'Agent ID', 'Rank', 'Position', 'Number', 'Count', 'Amount', 'Price', 'Value'];
        if (numericFields.some(numericField => fieldName.toLowerCase().includes(numericField.toLowerCase()))) {
          return;
        }
        
        const value = fields[fieldName];
        if (value && typeof value === 'string') {
          const emailValue = processEmailValue(value);
          if (emailValue) emails.add(emailValue);
          
          if (value.includes(',')) {
            value.split(',').forEach(part => {
              const emailValue = processEmailValue(part.trim());
              if (emailValue) emails.add(emailValue);
            });
          }
        }
        
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item && typeof item === 'string') {
              const emailValue = processEmailValue(item);
              if (emailValue) emails.add(emailValue);
            }
          });
        }
      });
      
      return Array.from(emails);
    };

    // Helper function to process email values
    const processEmailValue = (value) => {
      if (!value) return null;
      
      const normalized = String(value).trim().toLowerCase();
      
      if (normalized.includes('@') && normalized.includes('.') && normalized.length > 5) {
        const emailPatterns = [
          /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/,
          /[a-zA-Z0-9._%+-]+@imageproperty\.com\.au/,
          /[a-zA-Z0-9._%+-]+@imagenoperty\.com/,
          /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/
        ];
        
        for (const pattern of emailPatterns) {
          const match = normalized.match(pattern);
          if (match) {
            return match[0].toLowerCase();
          }
        }
        
        if (normalized.includes('@imageproperty.com.au') || normalized.includes('@imagenoperty.com')) {
          return normalized;
        }
      }
      
      return null;
    };

    const fetchData = async () => {
      try {
        if (!selectedUserEmail) {
          console.error("User email is not provided");
          return;
        }

        const normalizedUserEmail = normalizeEmail(selectedUserEmail);
        console.log(`🔍 STARTING COMPREHENSIVE SEARCH FOR: ${normalizedUserEmail}`);

        // Initialize all gauges to safe values first
        setGauges((prevGauges) => 
          prevGauges.map(gauge => ({
            ...gauge,
            number: 0
          }))
        );

        // Fetch ALL records and do comprehensive analysis
        const allRecords = await fetchAllRexSyncRecords();
        if (!allRecords || allRecords.length === 0) {
          console.error("❌ No records found in Airtable");
          setGauges((prevGauges) =>
            prevGauges.map((gauge, index) =>
              gauge.title === "Image Ranking" || index === 3
                ? { ...gauge, number: "N/A" }
                : { ...gauge, number: 0 }
            )
          );
          return;
        }

        console.log(`📊 TOTAL RECORDS FROM AIRTABLE: ${allRecords.length}`);

        // Comprehensive analysis of ALL records with enhanced email detection
        let foundUser = false;
        let userRecord = null;
        let allEmailsInDatabase = new Set();
        let emailToRecordMap = new Map();

        // IMPROVED: First pass - extract all emails and build mapping
        allRecords.forEach((record, index) => {
          const emails = extractAllEmails(record.fields);
          
          // Add all emails to our master set and map
          emails.forEach(email => {
            allEmailsInDatabase.add(email);
            if (!emailToRecordMap.has(email)) {
              emailToRecordMap.set(email, record);
            }
          });
          
          // Check if this record has the user's email (exact match)
          if (emails.includes(normalizedUserEmail)) {
            foundUser = true;
            userRecord = record;
            console.log(`🎯 EXACT MATCH: Found user in record ${index + 1}!`);
          }
        });

        console.log(`📧 ALL UNIQUE EMAILS IN DATABASE: ${allEmailsInDatabase.size} total`);

        // IMPROVED: Enhanced matching if user not found
        if (!foundUser) {
          console.log(`🔄 Trying enhanced email matching for: ${normalizedUserEmail}`);
          const allAvailableEmails = Array.from(allEmailsInDatabase);
          const bestMatch = findBestEmailMatch(normalizedUserEmail, allAvailableEmails);
          
          if (bestMatch) {
            userRecord = emailToRecordMap.get(bestMatch.match);
            foundUser = true;
            console.log(`✅ FOUND USER via enhanced matching: ${bestMatch.match} (${bestMatch.type} match)`);
          } else {
            console.error(`❌ CRITICAL: ${normalizedUserEmail} NOT FOUND in any Airtable record`);
            
            // Set all gauges to N/A since user not found
            setGauges((prevGauges) =>
              prevGauges.map((gauge, index) =>
                gauge.title === "Image Ranking" || index === 3
                  ? { ...gauge, number: "N/A" }
                  : { ...gauge, number: 0 }
              )
            );
            return;
          }
        }

        console.log(`✅ SUCCESS: Found ${normalizedUserEmail} in Airtable`);

        // IMPROVED: Ranking calculation with better validation
        console.log("=== 🏆 CALCULATING RANKING ===");
        
        // Create records for ranking
        const recordsForRanking = allRecords
          .map((record) => {
            const emails = extractAllEmails(record.fields);
            const gciValue = record.fields["GCI"];
            const gci = parseNumber(gciValue);
            
            return { 
              emails, 
              gci,
              rawGCI: gciValue,
              rawFields: record.fields,
              recordId: record.id
            };
          })
          .filter((r) => {
            // Only include records that have at least one email AND valid GCI > 0
            const hasValidEmail = r.emails.length > 0;
            const hasValidGCI = !isNaN(r.gci) && r.gci > 0;
            
            return hasValidEmail && hasValidGCI;
          });

        console.log(`📊 Records available for ranking: ${recordsForRanking.length} out of ${allRecords.length} total records`);

        // Sort descending by GCI (highest first)
        recordsForRanking.sort((a, b) => b.gci - a.gci);

        // DEBUG: Log top ranking array
        console.log("=== 🎯 TOP 10 RANKING DEBUG ===");
        recordsForRanking.slice(0, 10).forEach((rec, idx) => {
          console.log(`Rank ${idx + 1}: GCI ${rec.gci}, Emails:`, rec.emails);
        });

        // Build email -> rank map with duplicate handling
        const ranksByEmail = {};
        recordsForRanking.forEach((rec, idx) => {
          const rank = idx + 1;
          rec.emails.forEach((email) => {
            if (!ranksByEmail[email] || rank < ranksByEmail[email].rank) {
              ranksByEmail[email] = { rank, gci: rec.gci };
            }
          });
        });

        // IMPROVED: Enhanced rank lookup with better validation
        let userRankInfo = null;
        const userGCI = parseNumber(userRecord.fields["GCI"]);
        
        console.log(`📊 User GCI value from record: ${userGCI}`);
        console.log(`📊 User record fields:`, userRecord.fields);
        
        // Only assign rank if user has valid GCI > 0
        if (userGCI > 0) {
          userRankInfo = ranksByEmail[normalizedUserEmail];
          
          // If not found, try all emails from the user record
          if (!userRankInfo) {
            const userEmails = extractAllEmails(userRecord.fields);
            console.log(`🔍 Searching rank via user emails:`, userEmails);
            for (const email of userEmails) {
              if (ranksByEmail[email]) {
                userRankInfo = ranksByEmail[email];
                console.log(`🔄 Found rank via alternative email ${email}: ${userRankInfo.rank}`);
                break;
              }
            }
          }
        }

        // Set rank based on conditions - WITH PROPER ORDINAL SUFFIXES
        let finalRank = "N/A";
        if (userRankInfo && userRankInfo.rank > 0) {
          // FIXED: Use proper ordinal suffix (1st, 2nd, 3rd, etc.)
          const suffix = ordinalSuffix(userRankInfo.rank);
          finalRank = `${userRankInfo.rank}${suffix}`;
          console.log(`✅ FINAL RANK: ${finalRank} for ${normalizedUserEmail} with GCI ${userRankInfo.gci}`);
        } else {
          if (userGCI <= 0) {
            console.log(`❌ RANKING FAILED: ${normalizedUserEmail} has zero or invalid GCI (${userGCI})`);
          } else {
            console.log(`❌ RANKING FAILED: ${normalizedUserEmail} not found in ranking list despite having GCI ${userGCI}`);
          }
          finalRank = "N/A";
        }
        
        setGauges((prevGauges) =>
          prevGauges.map((gauge, index) =>
            gauge.title === "Image Ranking" || index === 3
              ? { ...gauge, number: finalRank }
              : gauge
          )
        );

        // Continue with the rest of your data fetching using the found record
        console.log("=== 📈 FETCHING OTHER DATA ===");

        // Use the already found userRecord for stats
        if (userRecord) {
          const stats = userRecord.fields;
          
          // Update GCI (show actual value even if 0)
          const gciRaw = stats["GCI"];
          const gciValue = parseNumber(gciRaw);
          console.log(`💰 Setting GCI to: ${gciValue} from raw value: ${gciRaw}`);
          
          setGauges((prev) =>
            prev.map((gauge, index) => {
              if (index === 1 && !React.isValidElement(gauge)) {
                return {
                  ...gauge,
                  number: gciValue,
                };
              }
              return gauge;
            })
          );
          setUserStats(stats);

          // Update Properties Sold
          const propertiesSold = parseNumber(stats["Properties Sold"]);
          setGauges((prevGauges) =>
            prevGauges.map((gauge, index) => {
              if (index === 0 && !React.isValidElement(gauge)) {
                return {
                  ...gauge,
                  number: propertiesSold,
                };
              }
              return gauge;
            })
          );
          setCoreMarketData(stats);

          // Calculate Projected GCI with safe math
          const startDate = new Date("2025-07-01");
          const currentDate = new Date();
          const timeDifference = currentDate - startDate;
          const daysSinceJuly = Math.floor(timeDifference / (1000 * 60 * 60 * 24)) + 1;
          
          let projectedGCI = 0;
          if (daysSinceJuly > 0 && gciValue > 0) {
            projectedGCI = (gciValue * 365) / daysSinceJuly;
          }
          
          setGauges((prevGauges) =>
            prevGauges.map((gauge, index) => {
              if ((index === 2 || gauge.title === "GCI Projected") && !React.isValidElement(gauge)) {
                return {
                  ...gauge,
                  number: projectedGCI,
                };
              }
              return gauge;
            })
          );
        }

        // Continue with your other data fetches for external APIs...
        try {
          const leadConversion = await fetchLeadCountByEmail(selectedUserEmail);
          if (leadConversion) {
            const conversionRate = leadConversion.conversionRate;
            setGauges((prevGauges) =>
              prevGauges.map((gauge, index) => {
                if ((index === 5 || gauge.text === "Leads %") && !React.isValidElement(gauge)) {
                  return {
                    ...gauge,
                    number: conversionRate !== undefined && conversionRate !== null ? conversionRate : 0,
                  };
                }
                return gauge;
              })
            );
          }
        } catch (error) {
          console.error("Error fetching lead conversion data:", error);
        }

        try {
          const pumReferral = await fetchPUMCountByEmail(selectedUserEmail);
          if (pumReferral) {
            const totalPUMReferrals = pumReferral.count;
            setGauges((prevGauges) =>
              prevGauges.map((gauge, index) => {
                if ((index === 4 || gauge.text === "PUM's Referral") && !React.isValidElement(gauge)) {
                  return {
                    ...gauge,
                    number: totalPUMReferrals !== undefined && totalPUMReferrals !== null
                      ? totalPUMReferrals
                      : 0,
                  };
                }
                return gauge;
              })
            );
          }
        } catch (error) {
          console.error("Error fetching PUM referral data:", error);
        }

        console.log("=== ✅ DATA FETCH COMPLETE ===");

      } catch (error) {
        console.error("❌ Error fetching data:", error);
        // Ensure gauges show safe values on error
        setGauges((prevGauges) => 
          prevGauges.map(gauge => ({
            ...gauge,
            number: gauge.title === "Image Ranking" ? "N/A" : 0
          }))
        );
      }
    };

    fetchData();
  }, [selectedUserEmail]);

  // Sales users effect
  useEffect(() => {
    const fetchSalesUsers = async () => {
      try {
        const usersRef = collection(db, "user_accounts");
        
        const q = query(
          usersRef,
          where("Department", "in", ["Sales", ["Sales"]])
        );

        const querySnapshot = await getDocs(q);
        const users = [];
        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          const department = userData.Department;

          if (
            department === "Sales" ||
            (Array.isArray(department) && department.includes("Sales"))
          ) {
            users.push({
              id: doc.id,
              name: userData.Employee,
              email: userData.ImageEmail,
            });
          }
        });

        users.sort((a, b) => a.name.localeCompare(b.name));

        console.log("Fetched Sales Users:", users);
        setSalesUsers(users);
      } catch (error) {
        console.error("Error fetching Sales users:", error);
      }
    };

    fetchSalesUsers();
  }, []);

  // Handle dropdown selection
  const handleUserSelect = (event) => {
    const selectedEmail = event.target.value;
    setSelectedUserEmail(selectedEmail); // Update the selected user email
  };

  const handleRemove = (index) => {
    const updatedGauges = gauges.filter((_, i) => i !== index);
    setGauges(updatedGauges);
  };

  const handleAdd = (index) => {
    setShowPopup(true);
    setNewGaugeIndex(index);
    setIsUpdating(false);
    setGaugePopupData({
      title: "",
      number: "",
      rangeFrom: 0,
      rangeTo: 100,
      interval: 10,
      tickMarks: 5,
    });
  };

  const handleUpdate = (index) => {
    setShowPopup(true);
    setNewGaugeIndex(index);
    setIsUpdating(true);
    const gauge = gauges[index];
    if (gauge) {
      setGaugePopupData({
        title: gauge.title || "",
        number: gauge.number || "",
        rangeFrom: gauge.rangeFrom || 0,
        rangeTo: gauge.rangeTo || 100,
        interval: gauge.interval || 10,
        tickMarks: gauge.tickMarks || 5,
      });
    }
  };

  const handleSubmitGauge = (formData) => {
    const { title, number, rangeFrom, rangeTo, interval, tickMarks } = formData;
    const newGauge = {
      title: title || "New Gauge",
      number: number || "0",
      size: gauges[newGaugeIndex]?.size || "medium",
      rangeFrom: parseInt(rangeFrom, 10),
      rangeTo: parseInt(rangeTo, 10),
      interval: parseInt(interval, 10),
      tickMarks: parseInt(tickMarks, 10),
    };

    const updatedGauges = [...gauges];
    if (isUpdating) {
      updatedGauges[newGaugeIndex] = newGauge;
    } else {
      updatedGauges.splice(newGaugeIndex + 1, 0, newGauge);
    }

    setGauges(updatedGauges);
    setShowPopup(false);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  // NEW: Interactive range configuration
  const handleRangeUpdate = (gaugeIndex, newRangeFrom, newRangeTo, newInterval) => {
    setGauges(prevGauges => 
      prevGauges.map((gauge, index) => 
        index === gaugeIndex 
          ? { 
              ...gauge, 
              rangeFrom: newRangeFrom,
              rangeTo: newRangeTo,
              interval: newInterval
            }
          : gauge
      )
    );
  };

  // NEW: Function to auto-adjust intervals based on range
  const calculateOptimalInterval = (rangeFrom, rangeTo) => {
    const range = rangeTo - rangeFrom;
    
    if (range <= 100) return 10;
    if (range <= 500) return 50;
    if (range <= 1000) return 100;
    if (range <= 5000) return 500;
    if (range <= 10000) return 1000;
    if (range <= 50000) return 5000;
    if (range <= 100000) return 10000;
    if (range <= 500000) return 50000;
    if (range <= 1000000) return 100000;
    if (range <= 5000000) return 500000;
    return 1000000;
  };

  // Show a loading spinner or placeholder while validating the token
  if (loading) {
    return <div>Loading...</div>; // Replace with a proper loading spinner
  }

  return (
    <>
      {/* NEW DROPDOWN CONTAINER */}
      <DropdownContainer>
        <select onChange={handleUserSelect} value={selectedUserEmail}>
          {salesUsers.map((user) => (
            <option key={user.id} value={user.email}>
              {user.name} {/* Display only the name */}
            </option>
          ))}
        </select>
      </DropdownContainer>

      <div id="rankingTable"></div>
      
      {/* UPDATED: First row with 3 gauges */}
      <RowContainer>
        {gauges.slice(0, 3).map((gauge, index) =>
          React.isValidElement(gauge) ? (
            gauge
          ) : (
            <GaugeContainer
              key={index}
              size={gauge.size}
              data-gauge-index={index}
            >
              <CircularGauge
                {...gauge}
                gaugeIndex={index}
                onRemove={() => handleRemove(index)}
                onAdd={() => handleAdd(index)}
                onUpdate={() => handleUpdate(index)}
                rangeFrom={gauge.rangeFrom}
                rangeTo={gauge.rangeTo}
                interval={gauge.interval}
                tickMarks={gauge.tickMarks}
              />
            </GaugeContainer>
          )
        )}
      </RowContainer>

      {/* UPDATED: Second row with remaining 3 gauges centered */}
      <RowContainer isSecondRow>
        {gauges.slice(3).map((gauge, index) =>
          React.isValidElement(gauge) ? (
            gauge
          ) : (
            <GaugeContainer
              key={index + 3}
              size={gauge.size}
              data-gauge-index={index + 3}
            >
              <CircularGauge
                {...gauge}
                gaugeIndex={index + 3}
                isSecondRow
                onRemove={() => handleRemove(index + 3)}
                onAdd={() => handleAdd(index + 3)}
                onUpdate={() => handleUpdate(index + 3)}
                rangeFrom={gauge.rangeFrom}
                rangeTo={gauge.rangeTo}
                interval={gauge.interval}
                tickMarks={gauge.tickMarks}
              />
            </GaugeContainer>
          )
        )}
      </RowContainer>
      {showPopup && (
        <SalesForm
          onSubmit={handleSubmitGauge}
          onClose={handleClosePopup}
          formData={gaugePopupData}
          isUpdateMode={isUpdating}
        />
      )}
    </>
  );
};

export default Sales_Admin;